<template lang="pug">
  .div
    el-dialog(:visible.sync="showDialog", :before-close="clear")
      .header-bold-18(v-if="status !== 'upload'") คอมเมนต์
      .header-bold-18.mar-top-20(v-else) อัพโหลดรูป
        span.header-regular-16 &nbsp; (ไฟล์มีขนาดไม่เกิน 2 MB)
      el-input(v-if="status !== 'upload'", type="textarea", rows="4", width="65%", v-model="content", @keydown="inputHandler")
      el-upload.text-center(v-else, ref="upload", drag, action="", accept=".jpeg, .jpg, .png", :limit="1", :on-exceed="handleExceed", :http-request="addAttachment", :auto-upload="false" :on-change="handleChange")
        i.el-icon-upload
        .el-upload__text Drop file here or &nbsp;
          em click to upload
      span.dialog-footer(slot="footer")
        el-button(type="primary", @click="clear()", plain).edit ยกเลิก
        el-button(type="primary", @click="createComment()", v-if="status === 'create'") คอมเมนต์
        el-button(type="primary", @click="updateComment()", v-if="status === 'update'") อัพเดต
        el-button(disabled="disabled", id="uploadButton", type="primary", @click="submitUpload()", v-if="status === 'upload'") อัพโหลด

    el-button(type="primary", @click="clickCreateComment()") เพิ่มคอมเมนต์
    el-button(type="primary", @click="clickCreateUpload()").secondary-button เพิ่มรูป

    .header-black-bold-22.mar-top-35 {{ count }} คอมเมนต์
    hr.line-break

    .comment(v-for="(comment, index) in list")
      el-row.pd-top-bottom-32
        el-col(:span="2")
          img.comment-img(v-if="comment.user.photo" :src="comment.user.photo")
          img.comment-img(v-else src="@/assets/avatar-grey@3x.png")
        el-col(:span="17")
          .comment-name
            span {{ comment.user.name }}
            span.comment-medium-16.mar-left-10 {{ comment.timestamp }}
          .comment-content(v-if="comment.type==='text'", v-html="changeText(comment.content)")
          .comment-content(v-if="comment.type==='image'")
            a(:href="comment.content" target="_blank")
              img.fit(:src="comment.content" width="347" height="237")
        el-col.text-right(:span="5")
          span.icon.comment-medium-16.mar-left-16(v-if="comment.canEdit" @click="editComment(comment.id, index)")
            i.el-icon-edit
            span.font-16
              |  แก้ไข
          span.icon.comment-medium-16.mar-left-16(v-if="comment.canDelete" @click="deleteComment(comment.id)")
            i.el-icon-delete
            span.font-16
              |  ลบ
      hr.line-break
</template>

<style lang="scss" scoped>
  .el-button--primary {
    height: 40px;
    margin-top: 20px;
    border-radius: 4px;
    font-size: 18px;
    border: solid 2px #409eff;
  }
  .comment {
    margin: 0;
  }
  .comment-img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
  .comment-name {
    font-family: Sukhumvit-Bold;
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #303133;
  }
  .comment-medium-16 {
    font-family: Sukhumvit;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #c0c4cc;
  }
  .line-break {
    margin: 0;
    padding: 0;
    border: solid 0.5px #dcdfe6;
  }
  .header-black-bold-22 {
    font-family: Sukhumvit-Bold;
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #303133;
  }
  .comment-content {
    font-family: 'Sukhumvit-Medium';
    font-size: 18px;
    font-weight: 300;
    overflow-wrap: break-word;
    color: #606266;
  }
  .icon {
    margin-left: 15px;
    color: #c0c4cc;
  }
  .icon:hover {
    cursor: pointer;
    color: #606266;
  }
  .font-16 {
    font-size: 16px;
    font-weight: 500;
  }
  .header-bold-18 {
    font-size: 18px;
    font-weight: bold;
    font-family: Sukhumvit-Bold;
  }
  .header-regular-16 {
    font-size: 16px;
    font-weight: normal;
    font-family: Sukhumvit;
  }
  .pd-top-bottom-32 {
    padding: 32px 0;
  }
  .mar-left-10 {
    margin-left: 10px;
  }
  .mar-left-16 {
    margin-left: 16px;
  }
  .mar-top-20 {
    margin-top: 20px;
  }
  .mar-top-35 {
    margin-top: 35px;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .fit {
    object-fit: cover;
  }
  .edit {
    background-color: #fff;
  }
  #uploadButton:disabled {
    border: solid 2px #a0cfff;
  }
</style>

<style lang="scss">
  .el-dialog__body {
    padding: 0 50px 20px 50px;
  }
  .el-dialog__footer {
    margin: 0;
    padding-top: 0;
  }
  .el-upload-dragger {
    margin-bottom: -20px;
  }
  .el-textarea {
    font-size: 18px;
    font-weight: 500;
    color: #606266;
  }
  .el-upload-list__item-name {
    margin-top: 20px;
  }
  .el-button+.el-button {
    margin-left: 15px;
    min-width: 80.92px;
  }
  .el-upload__text {
    font-weight: normal;
  }
  .cancel-button, .confirm-button {
    font-size: 18px;
    border-width: 2px;
  }
  .confirm-button {
    background-color: #409eff;
  }
  .cancel-button {
    border-color: #409eff;
    color: #409eff;
  }
  .cancel-button:hover {
    color: #fff;
    border-color: #409eff;
    background-color: #409eff;
  }
</style>

<script>
import CustomerCommentModel from '@/model/CustomerCommentModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'
import { UploadImageHandler } from '@/components/shared/UploadImageHandler'
export default {
  name: 'PatientComment',
  mixins: [GenericAPIHandler, UploadImageHandler],
  mounted () {
    this.getCommentList()
  },
  props: {
    patientId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      list: [],
      count: 0,
      status: '',
      content: '',
      commentId: '',
      showDialog: false,
    }
  },
  methods: {
    clickCreateComment () {
      this.content = ''
      this.status = 'create'
      this.showDialog = true
    },
    clickCreateUpload () {
      this.status = 'upload'
      this.showDialog = true
    },
    clear () {
      if (this.status === 'upload') {
        this.$refs.upload.clearFiles()
        this.handleUploadButton(true)
      }
      this.content = ''
      this.commentId = ''
      this.getCommentList()
      this.showDialog = false
    },
    async createComment () {
      try {
        await this.$api.Comment.create({ 'patientId': this.patientId, 'content': this.content })
        this.$message.success('เพิ่มคอมเมนต์แล้ว')
        this.clear()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async updateComment () {
      try {
        await this.$api.Comment.update({ 'id': this.commentId, 'content': this.content })
        this.$message.success('อัพเดตคอมเมนต์แล้ว')
        this.clear()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async deleteComment (id) {
      try {
        await this.$confirm('คุณต้องการลบคอมเมนต์นี้ ?', {
          type: 'warning',
          confirmButtonText: 'ลบ',
          cancelButtonText: 'ยกเลิก',
          cancelButtonClass: 'cancel-button',
          confirmButtonClass: 'confirm-button',
        })
      } catch (error) {
        return
      }
      try {
        await this.$api.Comment.remove(id)
        this.$message.success('ลบคอมเมนต์แล้ว')
        this.clear()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getCommentList () {
      try {
        const raw = await this.$api.Comment.list(this.patientId)
        this.list = raw.list.map((json) => CustomerCommentModel.fromJSON(json))
        this.count = raw.count
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    editComment (id, index) {
      this.commentId = id
      this.status = 'update'
      this.showDialog = true
      this.content = this.list[index].content
    },
    inputHandler (e) {
      if (e.keyCode === 13 && e.shiftKey) {
        e.preventDefault()
        this.content = `${this.content}\n`
      }
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    async addAttachment (upload) {
      if (!this.isImageAllowUpload(upload.file)) return
      try {
        await this.$api.Comment.createimage(this.patientId, upload.file)
        this.$message.success('เพิ่มรูปภาพแล้ว')
        this.clear()
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    handleChange (file, fileList) {
      if (fileList.length > 0) {
        this.handleUploadButton(false)
      }
    },
    handleUploadButton (val) {
      const buttonUpload = document.getElementById('uploadButton')
      if (val === true) {
        buttonUpload.disabled = true
        buttonUpload.classList.add('is-disabled')
      } else {
        buttonUpload.disabled = false
        buttonUpload.classList.remove('is-disabled')
      }
    },
    changeText (data) {
      // eslint-disable-next-line
      let urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      return data.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(urlRegex, function (url) {
        return `<a target="new" href="${url}"><u>${url}</u></a>`
      }).replace(/\n/g, '<br>')
    },
  },
}
</script>
